const version = process.env.REACT_APP_API_URL_VERSION; /* comment this line when build docker [DOCKER BUILD] */
export default {
  // Dropdown Start --------------------------------------------------------
  getSite: `/${version}/settings/sites`,
  getClient: `/${version}/settings/clients`,
  getIsisTask: `/${version}/settings/tasks`,
  getProduct: `/${version}/products/typeahead`,
  getEvent: `/${version}/audit/event`,
  getUom: '/dropdown/getuom',
  getDisposition: `${version}/settings/dispositions`,

  getOrderNo: '/dropdown/getorderno',
  getSupplier: `/${version}/settings/suppliers`,
  getCustomer: `/${version}/settings/customers`,
  getOrderType: '/dropdown/getordertype',

  getFilterDetailSP: '/supplier-management-options',
  // Dropdown End --------------------------------------------------------

  // Stock Holding Start --------------------------------------------------------
  stockHoldingSummary: `/${version}/stocks/holding`,
  getStockHoldingHearder: '/getStockholdingColumn',
  // Stock Holding End --------------------------------------------------------

  // Stock Movement Start --------------------------------------------------------
  stockMovement: `/${version}/stocks/movement`,
  // Stock Movement End --------------------------------------------------------

  // purchace Order Start --------------------------------------------------------
  purchaseOrder: `/${version}/purchase-orders`,
  purchaseOrderCreate: `/${version}/purchase-orders`,
  getPOResources: `/${version}/preferences/purchase-order-options`,
  supplierPoCreate: `/${version}/purchase-orders/store-supplier`,
  supplierCLientCheck: `/${version}/purchase-orders/check-client-supplier`,
  supplierCheck: `/${version}/purchase-orders/check-supplier-number`,

  // purchace Order End --------------------------------------------------------
  // user log Start --------------------------------------------------------
  auditLog: `/${version}/audit`,

  // user log End --------------------------------------------------------

  // rejections Start --------------------------------------------------------
  rejections: `/${version}/audit/rejected`,
  getStream: `/${version}/settings/stream`,

  // rejections End --------------------------------------------------------

  // sales Order Start --------------------------------------------------------
  salesOrder: `/${version}/sales-orders`,
  salesOrderCreate: `/${version}/sales-orders`,
  getSoResources: `/${version}/preferences/sales-order-options`,
  getSoIdentity: '/getSoIdentity',
  customerSoCreate: `/${version}/sales-orders/store-customer`,
  customerCLientCheck: `/${version}/sales-orders/check-client-customer`,
  customerCheck: `/${version}/sales-orders/check-customer-number`,
  // sales Order End --------------------------------------------------------

  // User Management Start --------------------------------------------------------
  userManagementModuleAccess: `/${version}/preferences/user-modules`,
  userManagementCreate: `/${version}/users`,
  userManagementListUser: `/${version}/users`,
  userManagementUser_Detail: `/${version}/users/`,
  userManagementUpdate: `/${version}/users/`,
  userManagementModuleUpdate: `/${version}/audit/modul-access/`,
  userManagementresetpassword: `/${version}/users/`,
  userManagementCheckMailValidation: `/${version}/users/check-email`,
  userManagementUpgradeUser: `/${version}/users/upgrade-role`,
  // User Management End --------------------------------------------------------

  // Supplier Management ----------------------------------------------------
  supplierManagement: `${version}/supplier-management`,
  // Supplier Management End ----------------------------------------------------

  stockDateRange: `/${version}/stocks/movement/date-range`,
  stockAgeProfile: '/stockageprofile',

  userLogin: '/auth/login',
  userLogout: '/auth/logout',
  resetPassword: '/auth/forgot-password',

  orderCheck: '/orderCheck',
  fieldLabel: `/${version}/settings/field-label`,
  logo: `${process.env.REACT_APP_API_URL}/images/${process.env.REACT_APP_CLIENT}`,
  env: process.env /* comment this line when build docker [DOCKER BUILD] */,
  // env: window._env_ /* uncomment this line when build docker [DOCKER BUILD]] */
  client: process.env.REACT_APP_CLIENT,
  // client name
};
